"use client";

import { useLocale } from "@i18n/react";
import { useSearch } from "@packages/framework";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { useRequestMutation } from "../../../../../request/hooks/useRequestMutation";
import { keyCommunityAssignments } from "../keyCommunityAssignments";
import type { CommunityAssignmentsMultiple } from "./schema/communityAssignmentsMultipleSchema";

type UseRequestCommunityAssignmentsMultipleProps = {
  id: number;
};

export const useRequestCommunityAssignmentsMultiple = ({
  id,
}: UseRequestCommunityAssignmentsMultipleProps) => {
  const locale = useLocale();
  const queryClient = useQueryClient();
  const search = useSearch();

  const invalidateQueries = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [
        keyCommunityAssignments({
          id,
          search: search.get("search") ?? "",
        }),
        locale,
      ],
    });
  }, [id, locale, queryClient, search]);

  return {
    mutationPost: useRequestMutation<any, CommunityAssignmentsMultiple>({
      mutationFnRequestProps: (data) => ({
        urlBackendPath: `/communities/${id}/admin/assignments/multiple`,
        method: "POST",
        body: JSON.stringify({ assignment_items: data }),
      }),
      onSuccess: () => invalidateQueries(),
    }),
  };
};
